module.exports = __webpack_public_path__ + "img/013.93b5841b.jpg";